// Brand panel colors: one click applies a brand color to what is selected,
// through the same actions the editor's own controls dispatch.
//   text box (BasicText / legacy RichText) → text color
//   shape (ShapeOverlay)                   → shape color
//   nothing selected                       → scene background
// Anything else is left alone ("unsupported").

import { CHANGE_GLOBAL_CONFIG, updatePluginToolbar, updateViewToolbar } from "../../common/actions";
import { forceHtmlCssProperty } from "../../common/common_tools";
import { CUSTOM_THEME_ID } from "../components/nav_bar/scene_theme_palette/resolveCustomModeFromToolbar";

const TEXT_PLUGINS = new Set(["BasicText", "RichText"]);

/** `#rrggbb` → `rgba(r,g,b,1)` — the canvas only paints a background as a color in this form. */
export function hexToRgbaCss(hex) {
  const n = parseInt(String(hex).replace("#", ""), 16);
  return `rgba(${(n >> 16) & 0xff},${(n >> 8) & 0xff},${n & 0xff},1)`;
}

/** @returns {"text" | "shape" | "background" | "unsupported"} what the color went to */
export function applyBrandColor(dispatch, getState, hex) {
  const st = getState().undoGroup.present;
  const page =
    st.containedViewSelected && st.containedViewSelected !== 0
      ? st.containedViewSelected
      : st.navItemSelected;
  const boxId = st.boxSelected;
  const toolbar =
    boxId !== -1 && boxId != null && st.pluginToolbarsById ? st.pluginToolbarsById[boxId] : null;

  if (toolbar && TEXT_PLUGINS.has(toolbar.pluginId)) {
    const html = toolbar.state && toolbar.state.__text;
    // Inline span colors would beat the box color, so the html is recolored too
    // (same two fields the text pill writes) — as one undo step.
    dispatch(
      html
        ? updatePluginToolbar(
            boxId,
            "main",
            "state",
            ["textColor", "__text"],
            [hex, forceHtmlCssProperty(html, "color", hex)],
            [],
            page
          )
        : updatePluginToolbar(boxId, "main", "state", "textColor", hex, [], page)
    );
    return "text";
  }

  if (toolbar && toolbar.pluginId === "ShapeOverlay") {
    dispatch(updatePluginToolbar(boxId, "main", "state", "color", hex, [], page));
    return "shape";
  }

  if (toolbar) return "unsupported";

  // Same payload as the theme modal's custom color (ThemePaletteModal).
  dispatch(
    updateViewToolbar(page, {
      themeId: CUSTOM_THEME_ID,
      customMode: "color",
      background: hexToRgbaCss(hex),
      backgroundAttr: "full",
      backgroundOpacity: 100,
    })
  );
  const globalTheme = st.globalConfig && st.globalConfig.globalTheme;
  if (globalTheme && globalTheme.applyToAll) {
    // A theme applied to all scenes would paint over this scene's color.
    dispatch({
      type: CHANGE_GLOBAL_CONFIG,
      payload: { prop: "globalTheme", value: { ...globalTheme, applyToAll: false } },
    });
  }
  return "background";
}
